import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { BrowserView, MobileView } from 'react-device-detect'
import { Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import { Fade, Zoom } from 'react-awesome-reveal'
import { useTranslation } from 'react-multi-lang'
import axios from 'axios'
import { RotatingLines } from 'react-loader-spinner'
import '../../styles/Actuality/Actuality.css'

function Actuality() {

    const navigate = useNavigate()
    const text = useTranslation()
    const [isLoading, setIsLoading] = useState(true)
    const [actualities, setActualities] = useState([])

    useEffect(() => {

        window.scrollTo({ top: 0, behavior: 'instant' })
        getActuality()

    }, [])

    function getActuality() {

        setIsLoading(true)
        axios.get(process.env.REACT_APP_API_URL + 'actuality').then((response) => {
            response.data.map((item) => {
                item.date = new Date(item.date).toLocaleDateString("fr-FR")
                item.createdAt = new Date(item.createdAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                item.updatedAt = new Date(item.updatedAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                item.image = process.env.REACT_APP_API_URL + 'actuality/' + item.id + '/image'
                return item
            })
            setActualities(response.data)
            setIsLoading(false)
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    return (

        <>
            <Helmet>
                <meta name="title" content="Nos actualités - Vietnamensemble" />
                <meta name="description" content="Association Vietnamensemble, nos actualités" />
                <meta property="og:title" content="Nos actualités - Vietnamensemble" />
                <meta property="og:description" content="Association Vietnamensemble, nos actualités" />
                <meta property="og:url" content="https://www.vietnamensemble.org/actualités" />
                <link rel="canonical" href="https://www.vietnamensemble.org/actualités" />
            </Helmet>

            <BrowserView>
                <div id='actuality'>
                    <Fade>
                        <div className='actualityTitle'>{text('actuality.title')}</div>
                    </Fade>
                    {isLoading ?
                        <div className='loader'>
                            <RotatingLines
                                strokeColor={"#5b7c18"}
                                strokeWidth={"5"}
                                animationDuration={"1"}
                                width={"40"}
                                visible={true}
                            />
                        </div>
                        :
                        <div className='homeActualityRow'>
                            <Row>
                                {actualities.map((item, index) => {
                                    return (
                                        <Col key={item.id} sm={4}>
                                            <Zoom duration={500}>
                                                <div className='actualityItem' onClick={() => navigate('/actualités/' + item.id, { state: { actuality: item } })}>
                                                    <div className='actualityItemImage'>
                                                        <img src={item.image} width={'100%'} alt="actualityImage" loading="lazy" />
                                                    </div>
                                                    <div className='actualityItemDate'>
                                                        <FontAwesomeIcon icon={faClock} className='actualityItemDateIcon' />
                                                        {item.date}
                                                    </div>
                                                    <div className='actualityItemTitle'>{item.title}</div>
                                                </div>
                                            </Zoom>
                                        </Col>
                                    )
                                })}
                            </Row>
                        </div>
                    }
                </div>
            </BrowserView>

            <MobileView>
                <div id='actuality'>
                    <Fade>
                        <div className='actualityTitle'>{text('actuality.title')}</div>
                    </Fade>
                    {isLoading ?
                        <div className='loader'>
                            <RotatingLines
                                strokeColor={"#5b7c18"}
                                strokeWidth={"5"}
                                animationDuration={"1"}
                                width={"40"}
                                visible={true}
                            />
                        </div>
                        :
                        <Row>
                            {actualities.map((item, index) => {
                                return (
                                    <Col key={item.id} sm={4}>
                                        <Zoom duration={500}>
                                            <div className='actualityItemMobile' onClick={() => navigate('/actualités/' + item.id, { state: { actuality: item } })}>
                                                <div className='actualityItemImage'>
                                                    <img src={item.image} width={'100%'} alt="actualityImage" loading="lazy" />
                                                </div>
                                                <div className='actualityItemDate'>
                                                    <FontAwesomeIcon icon={faClock} className='actualityItemDateIcon' />
                                                    {item.date}
                                                </div>
                                                <div className='actualityItemTitle'>{item.title}</div>
                                            </div>
                                        </Zoom>
                                    </Col>
                                )
                            })}
                        </Row>
                    }
                </div>
            </MobileView>
        </>

    )

}

export default Actuality
